import * as React from 'react';
import Icon from 'react-native-vector-icons/AntDesign'
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { redBorderInputColor } from '../../common/colors';
import { Dimensions } from "react-native";

const Error = (props) => {
    return props.error && 
    <View style={styles.errorinDB}> 
        <View>
            <Text style={styles.textError}> 
                <Icon style={styles.alertIcon} name='exclamationcircle'> </Icon>
                {props.error}
            </Text>
        </View>
    </View>
}

export default Error;

const styles = StyleSheet.create({
    errorinDB: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    textError: {
        color: redBorderInputColor,
        paddingBottom: 20,
        fontSize: 12,
    },
    alertIcon: {
        paddingRight: 3,
    },
})
